import React, {Component} from 'react';
import styles from './MainPageCategoriesGrid.scss';
import _ from 'lodash';


export default class CategoryWithLinks extends Component {
  render() {
    const {links, photo, name} = this.props;
    const renderedLinks = _.map(links, (link, i) => (
      <a
        key={`cat-link-${i}`}
        href="#"
        className={styles.categoryLink}>
        {link}
      </a>
    ));
    return (
      <div className={styles.categoryWithLinks} style={{
          backgroundImage: `url(${photo})`,
          backgroundSize: 'cover'
        }}>
        <h2 className={styles.categoryName}>{name}</h2>
        <a href="#">
          <img
            className={styles.categoryBgImg}
            src={photo} />
        </a>
        <div className={styles.categoryLinksContainer}>
          {renderedLinks}
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/MainPage/elements/MainPageCategoryWithLinks.jsx
 **/